type DataLayerParams = {
  event: string;
  category?: string;
  value?: any;
  [key: string]: any; // 任意の追加プロパティを許可
};

export const pushDataLayer = (params: DataLayerParams) => {
  if (!window?.dataLayer) {
    return;
  }
  window.dataLayer.push(params);
};

export class Analytics {
  static handleLineClick(category: string): void {
    pushDataLayer({
      event: 'click',
      category,
      value: 'line'
    });
  }

  static handleLinePageView(category: string): void {
    pushDataLayer({
      event: 'line popup on screen',
      category,
      value: 'line'
    });
  }

  static handleRecruitmentView(recruitmentId: number, companyId: number, userId: number, role: 'company' | 'person' | 'anonymous', status: 'stopped' | 'released' | 'limited'): void {
    pushDataLayer({
      event: 'view_recruitment',
      recruitment_id: recruitmentId,
      company_id: companyId,
      user_id: userId,
      role: role,
      status: status
    });
  }
}
